<template>
    <div
      v-if="isVisible"
      class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
    
      <div class="relative bg-white rounded-lg shadow-lg max-w-[656px] w-full p-12">
        <!-- Close button -->
        <button
          @click="closePopup"
          class="absolute top-6 right-8 text-gray-800 hover:text-gray-600"
        >
          <i class="pi pi-times" style="font-size: 0.75rem"></i>
        </button>
  
        <div class="flex flex-col items-center justify-content  py-8 ">
          <!-- SVG Icon -->
          <div class="mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="106"
              height="105"
              viewBox="0 0 106 105"
              fill="none"
              class="mx-auto"
            >
              <path
                opacity="0.2"
                d="M41.9709 80.8459L24.6541 63.5291L17.1072 84.2953C16.8967 84.8678 16.8544 85.4886 16.9855 86.0844C17.1165 86.6802 17.4154 87.226 17.8467 87.6573C18.2781 88.0887 18.8239 88.3876 19.4196 88.5186C20.0154 88.6496 20.6363 88.6074 21.2088 88.3968L41.9709 80.8459Z"
                fill="#369DA3"
              />
              <path
                opacity="0.2"
                d="M32.5291 41.8727L63.6272 72.9708L80.4436 66.8595C80.9495 66.6763 81.401 66.3684 81.7561 65.9642C82.1113 65.56 82.3586 65.0727 82.4752 64.5475C82.5918 64.0222 82.5738 63.476 82.423 62.9595C82.2722 62.4431 81.9934 61.973 81.6125 61.5931L43.9068 23.9079C43.5268 23.5279 43.057 23.25 42.5411 23.0997C42.0251 22.9495 41.4795 22.9318 40.9549 23.0483C40.4303 23.1649 39.9435 23.4118 39.5397 23.7664C39.1358 24.121 38.828 24.5717 38.6445 25.0768L32.5291 41.8727Z"
                fill="#369DA3"
              />
              <path
                d="M17.1072 84.2952L38.6445 25.0768C38.8277 24.5709 39.1356 24.1194 39.5398 23.7642C39.9439 23.4091 40.4313 23.1617 40.9565 23.0452C41.4818 22.9286 42.028 22.9465 42.5445 23.0973C43.0609 23.2481 43.531 23.5269 43.9109 23.9079L81.5961 61.593C81.976 61.9733 82.2538 62.4434 82.4037 62.9596C82.5537 63.4758 82.571 64.0215 82.4541 64.5462C82.3371 65.0708 82.0897 65.5575 81.7347 65.9612C81.3796 66.3648 80.9285 66.6723 80.4231 66.8553L21.2047 88.3926C20.6328 88.6015 20.0131 88.6427 19.4187 88.5113C18.8242 88.3798 18.2796 88.0813 17.8491 87.6508C17.4186 87.2203 17.12 86.6757 16.9886 86.0812C16.8572 85.4867 16.8983 84.8671 17.1072 84.2952Z"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M69.4063 29.5313C69.4063 29.5313 69.4063 19.6875 79.25 19.6875C89.0938 19.6875 89.0938 9.84375 89.0938 9.84375"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M59.5625 6.5625V16.4063"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M89.0938 45.9375L95.6563 52.5"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M89.0938 32.8125L98.9375 29.5312"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M32.5291 41.8728L63.6272 72.9709"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M41.9709 80.8459L24.6541 63.5291"
                stroke="#369DA3"
                stroke-width="8.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
  
          <!-- Title -->
          <h2 class="text-2xl font-semibold mb-2 text-center">
            Congratulations! Your campaign is on its way
          </h2>
  
          <!-- Description -->
          <p class="text-gray-600 text-center mb-8 text-base leading-relaxed">
            We've received your payment. Your campaign is under review<br />
            and will go live as scheduled. This usually takes less than<br />
            24 hours.
          </p>
  
          <!-- Buttons - Changed justify-center to justify-end -->
          <div class="flex justify-end gap-4 w-full">
            <button
              @click="viewCampaign"
              class="px-6 py-2.5 border border-solid border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
            >
              View Campaigns
            </button>
              <button
              @click="addCampaign"
              class="px-6 py-2.5 bg-[#369DA3] text-white rounded-md hover:bg-teal-800  transition-colors flex items-center gap-2"
            >
              <i class="pi pi-plus" style="font-size: 0.75rem"></i>
              Add Campaign
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import store from "../../store";
  import router from "../../router/router";
  export default {
    data() {
      return {
        isVisible: true,
      };
    },
    methods: {
      closePopup() {
        this.isVisible = false;
      },
      viewCampaign() {
        // Logic for viewing the campaign
        this.closePopup();
        this.$router.push('/campaigns');
        this.$store.commit("restoreStat");
      },
      addCampaign() {
        this.closePopup();
        this.$store.commit("restoreStat");
      },
    },
  };
  </script>
  
  <style>
  .parent-div {
    position: relative;
  }
  </style>
  